<template>
  <canvas width="60" height="60" ref="circleCanvas" id="canvas"/>
</template>
<script>
    export default {
      watch: {
        progress (nv) {
          // clear the state.
          this.progress = nv
          this.draw()
        }
      },
      data: () => {
        return {
          cx: 29,
          cy: 29,
          cr: 29
        }
      },
      props: ['target', 'progress'],
      computed: {
      },
      methods: {
        draw () {
          // debugger
          let progress = this.progress || 0
          let progressPercent = 2 * Math.PI * progress / this.target - 0.5 * Math.PI
          let ctx = this.$refs.circleCanvas.getContext('2d')
          ctx.beginPath()
          ctx.moveTo(this.cx, this.cy)
          ctx.arc(this.cx, this.cy, this.cr, progressPercent, 1.5 * Math.PI)
          ctx.moveTo(this.cx, this.cy)
          ctx.fillStyle = '#880913'
          ctx.fill()
        }
      }
    }
</script>
<style scoped>
  #canvas {
    margin-left: 1px;
    margin-top: 11px;
  }

  @media only screen and (min-width: 2000px) {
    #canvas {
      height: 222px;
      width: 233px;
      margin-left: 13px;
      margin-top: 49px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/canvas-progress.vue